
import { Card, CardContent } from "@/components/ui/card";
import { differenceInWeeks } from "date-fns";
import { Progress } from "@/components/ui/progress";
import { Baby, Calendar, TrendingUp } from "lucide-react";

interface GestationStatsProps {
  pregnancyStartDate: Date;
  currentWeek: number | null;
  dueDate: Date | null;
}

export const GestationStats = ({ pregnancyStartDate, currentWeek, dueDate }: GestationStatsProps) => {
  const totalWeeks = 40;
  const remainingWeeks = dueDate ? differenceInWeeks(dueDate, new Date()) : null;
  const progress = currentWeek ? (currentWeek / totalWeeks) * 100 : 0;

  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-3">
        <Card className="overflow-hidden border-l-4 border-l-blue-500 transition-all duration-300 hover:shadow-md">
          <CardContent className="p-6 flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-full">
              <Baby className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <div className="text-2xl font-bold">{currentWeek || 0}</div>
              <p className="text-xs text-muted-foreground">Semaine actuelle</p>
            </div>
          </CardContent>
        </Card>
        <Card className="overflow-hidden border-l-4 border-l-purple-500 transition-all duration-300 hover:shadow-md">
          <CardContent className="p-6 flex items-center gap-4">
            <div className="bg-purple-100 p-3 rounded-full">
              <Calendar className="h-6 w-6 text-purple-600" />
            </div>
            <div>
              <div className="text-2xl font-bold">{remainingWeeks || 0}</div>
              <p className="text-xs text-muted-foreground">Semaines restantes</p>
            </div>
          </CardContent>
        </Card>
        <Card className="overflow-hidden border-l-4 border-l-pink-500 transition-all duration-300 hover:shadow-md">
          <CardContent className="p-6 flex items-center gap-4">
            <div className="bg-pink-100 p-3 rounded-full">
              <TrendingUp className="h-6 w-6 text-pink-600" />
            </div>
            <div>
              <div className="text-2xl font-bold">{Math.round(progress)}%</div>
              <p className="text-xs text-muted-foreground">Progression</p>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <Card className="transition-all duration-300 hover:shadow-md">
        <CardContent className="p-6">
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-lg font-medium">Progression de votre grossesse</span>
              <span className="font-medium bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-sm">{Math.round(progress)}%</span>
            </div>
            <Progress value={progress} className="h-3 bg-pink-100">
              <div className="h-full bg-gradient-to-r from-pink-400 to-purple-600 rounded-full" style={{ width: `${progress}%` }} />
            </Progress>
            <div className="flex justify-between text-xs text-muted-foreground">
              <div className="flex items-center gap-1.5">
                <div className="w-3 h-3 rounded-full bg-pink-400" />
                <span>Semaine 1</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-3 h-3 rounded-full bg-purple-600" />
                <span>Semaine 40</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
